import { create } from 'zustand';
export const SummaryDefaultState = {
  LESSON: {},
  SHORT_FORM_CONTENT: {},
  TRACK: {}
};
export const useSummarySessionConfig = create(set => Object.assign({}, SummaryDefaultState, {
  deleteSummaryState: ({
    contentType,
    contentId
  }) => {
    set(state => {
      const filteredState = Object.assign({}, state[contentType]);
      delete filteredState[contentId];
      return {
        [contentType]: filteredState
      };
    });
  },
  setSummaryTaskId: ({
    contentType,
    contentId,
    taskId
  }) => {
    set(state => ({
      [contentType]: Object.assign({}, state[contentType], {
        [contentId]: Object.assign({}, state[contentType][contentId], {
          taskId
        })
      })
    }));
  },
  setSummaryData: ({
    contentType,
    contentId,
    summary,
    correlationId,
    videoDuration
  }) => {
    set(state => ({
      [contentType]: Object.assign({}, state[contentType], {
        [contentId]: Object.assign({}, state[contentType][contentId], {
          summary,
          correlationId,
          videoDuration
        })
      })
    }));
  }
}));
export const useSummarySession = () => {
  const {
    LESSON,
    SHORT_FORM_CONTENT,
    TRACK,
    deleteSummaryState,
    setSummaryTaskId,
    setSummaryData
  } = useSummarySessionConfig();
  const getSummaryState = (id, contentType) => {
    switch (contentType) {
      case 'LESSON':
        return LESSON[id];
      case 'SHORT_FORM_CONTENT':
        return SHORT_FORM_CONTENT[id];
      case 'TRACK':
        return TRACK[id];
      default:
        return undefined;
    }
  };
  return {
    deleteSummaryState,
    getSummaryState,
    setSummaryTaskId,
    setSummaryData
  };
};